import Vue from 'vue'

Vue.component('NavItem', () => import('./NavItem.vue'))
Vue.component('NavSubItem', () => import('./NavSubItem.vue'))
Vue.component('NavItemDrop', () => import('./NavItemDrop.vue'))
Vue.component('SidebarActions', () => import('./SidebarActions.vue'))
